import { render, staticRenderFns } from "./ReUrgency.vue?vue&type=template&id=d657bf10&scoped=true"
import script from "./ReUrgency.vue?vue&type=script&lang=js"
export * from "./ReUrgency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d657bf10",
  null
  
)

export default component.exports